import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { environment } from '../environments/environment';
import { API_BASE_URL } from '../shared/service-proxies/service-proxies';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { DashboardLiveComponent } from "./dashboard-live/dashboard-live.component";
import { InventoryComponent } from "./inventory/inventory.component";
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as ApiServiceProxies from '../shared/service-proxies/service-proxies';
import { AuthGuard } from "./security/auth-guard.service";
import { AuthService } from "./security/auth.service";
import { AssetsWidgetComponent, ContainersWidgetComponent, VehicleJobsWidgetComponent, ServicesWidgetComponent, InTransitMapComponent, JobsWidgetComponent } from './widgets';
import { MomentModule } from 'ngx-moment';
import { PageHelperService } from './helpers/page-helper.service';
import { LocalStorageService } from './services/local-storage.service';
import { AppRoutingModule } from './app-routing.module';
import { ReportsComponent } from './reports/reports.component';
import { DashboardActiveComponent } from './dashboard-active/dashboard-active.component';
import { ApplicationStatusService } from './services/application-status.service';
import { LocationDetailComponent } from './location-detail/location-detail.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SmallGraphWidgetComponent } from './widgets/small-graph-widget/small-graph-widget.component';
import { PagingComponent } from './widgets/paging/paging.component';
import { RouteMapComponent } from './route-map/route-map.component';
import { RoadsService } from './services/roads.service';
import { SummaryTotalsComponent } from './widgets/summary-totals/summary-totals.component';
import { LocationsComponent } from './locations/locations.component';
import { SessionStorageService } from './services/session-storage.service';
import { ReportsBuilderComponent } from './reports-builder/reports-builder.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HasClaimDirective } from './security/has-claim.directive';
import { ActivityReportComponent } from './activity-report/activity-report.component';
import { ImageHostComponent } from './image-host/image-host.component';
import { AdminAlertsComponent, DialogFromMenuExampleDialog } from './admin-alerts/admin-alerts.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { VehicleTypeSwitchComponent } from './widgets/vehicle-type-switch/vehicle-type-switch.component';
import { IntegrationReportComponent, ActionsDialog, RentalDialog, ContactDetailsDialog, NotesDialog, ResetDialog } from "./integration-report/integration-report.component";
import { ContainerAvailabilityReportComponent } from "./container-availability-report/container-availability-report.component";
import { ContainerAvailabilityComponent } from "./container-availability/container-availability.component";
import { DepotDetailsComponent } from "./depot-details/depot-details.component";
import { DevicesComponent } from './devices/devices.component';
import { CustomerSettings } from './services/customer-settings-service';
import { DevicesAlertComponent } from './device-alert/device-alert.component';
import { UserDataInitializerProvider } from './security/UserDataInitializerProvider';
import { SetHeightDirective } from './directives/set-height-directive.directive';
import { ContainersPopupComponent } from './widgets/containers-popup/containers-popup.component';
import { ImagePopupComponent } from './widgets/image-popup/image-popup.component';
import { PopoverComponent } from './widgets/popover/popover.component';
import { PopoverDirective } from './widgets/popover/popover.directive';
import { BillingSummaryComponent } from './billing-summary/billing-summary.component';
import { BillingDetailsComponent } from './billing-details/billing-details.component';
import { CustomerCollectionsComponent } from './customer-collections/customer-collections.component';
import { ContainerMapComponent } from './container-map/container-map.component';
import { DepotDetailsComponent2 } from './depot-details-2/depot-details-2.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    DashboardLiveComponent,
    DashboardActiveComponent,
    FetchDataComponent,
    AssetsWidgetComponent,
    ContainersWidgetComponent,
    VehicleJobsWidgetComponent,
    ServicesWidgetComponent,
    JobsWidgetComponent,
    InTransitMapComponent,
    ReportsComponent,
    LocationDetailComponent,
    CustomerDetailsComponent,
    SmallGraphWidgetComponent,
    PagingComponent,
    RouteMapComponent,
    SummaryTotalsComponent,
    LocationsComponent,
    InventoryComponent,
    ReportsBuilderComponent,
    HasClaimDirective,
    ActivityReportComponent,
    ImageHostComponent,
    AdminAlertsComponent,
    DialogFromMenuExampleDialog,
    VehicleTypeSwitchComponent,
    IntegrationReportComponent,
    ContactDetailsDialog,
    NotesDialog,
    RentalDialog,
    ActionsDialog,
    ResetDialog,
    ContainerAvailabilityReportComponent,
    ContainerAvailabilityComponent,
    DepotDetailsComponent,
    DepotDetailsComponent2,
    CustomerCollectionsComponent,
    DevicesComponent,
    DevicesAlertComponent,
    SetHeightDirective,
    ContainersPopupComponent,
    ImagePopupComponent,
    PopoverComponent,
    PopoverDirective,
    BillingSummaryComponent,
    BillingDetailsComponent,
    ContainerMapComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MomentModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRippleModule,
    MatSlideToggleModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatCheckboxModule,
    MatRadioModule,
    NgxMatSelectSearchModule,
    FormsModule,
    ReactiveFormsModule,
    NgxChartsModule
  ],
  providers: [
    ApiServiceProxies.BlackboxService,
    ApiServiceProxies.UserApiService,
    ApiServiceProxies.DashboardService,
    ApiServiceProxies.EmbedInfoService,
    ApiServiceProxies.CustomerService,
    ApiServiceProxies.LocationDetailsService,
    ApiServiceProxies.MovementService,
    ApiServiceProxies.AssetLocationService,
    ApiServiceProxies.DepotService,
    ApiServiceProxies.AdminAlertService,
    ApiServiceProxies.ContainerAssignmentService,
    ApiServiceProxies.ReportsService,
    ApiServiceProxies.AgreementsService,    
    ApiServiceProxies.DemoCustomerService,
    ApiServiceProxies.AssetDeviceService,
    ApiServiceProxies.CustomerSettingsService,
    ApiServiceProxies.ContainerAvailabilityService,
    ApiServiceProxies.CustomerDetailsService,
    ApiServiceProxies.AssetDamageService,
    ApiServiceProxies.FinanceService,
    ApiServiceProxies.LocationService,
    ApiServiceProxies.JobService,
    AuthService,
    AuthGuard,
    LocalStorageService,
    CustomerSettings,
    SessionStorageService,
    PageHelperService,
    {
      provide: API_BASE_URL,
      useValue: environment.apiRoot
    },
    ApplicationStatusService,
    Title,
    { 
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB' 
    },
    RoadsService,
    UserDataInitializerProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
